import { render, staticRenderFns } from "./init-process.vue?vue&type=template&id=e309d2ba&scoped=true&"
import script from "./init-process.vue?vue&type=script&lang=js&"
export * from "./init-process.vue?vue&type=script&lang=js&"
import style0 from "./init-process.vue?vue&type=style&index=0&id=e309d2ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e309d2ba",
  null
  
)

export default component.exports